(function () {
  var MOBILE_MAX = 749;

  function parseViewsText(text) {
    if (!text) return 0;
    var value = String(text).trim();
    if (!value) return 0;

    var mnMatch = value.match(/^([\d.,]+)\s*mn/i);
    if (mnMatch) {
      return Math.round(parseFloat(mnMatch[1].replace(',', '.')) * 1000000);
    }

    var bMatch = value.match(/^([\d.,]+)\s*b/i);
    if (bMatch) {
      return Math.round(parseFloat(bMatch[1].replace(',', '.')) * 1000);
    }

    var digits = value.replace(/[^\d]/g, '');
    return digits ? parseInt(digits, 10) : 0;
  }

  function formatViewsCount(count) {
    var safeCount = Math.max(0, count || 0);

    if (safeCount >= 1000000) {
      var millions = safeCount / 1000000;
      var millionsText = millions % 1 === 0 ? String(millions) : millions.toFixed(1).replace('.', ',');
      return millionsText + ' Mn';
    }

    if (safeCount >= 1000) {
      var thousands = safeCount / 1000;
      var thousandsText = thousands % 1 === 0 ? String(thousands) : thousands.toFixed(1).replace('.', ',');
      return thousandsText + ' B';
    }

    return String(safeCount);
  }

  function getViewsStorageKey(sectionId, blockId) {
    return 'svs-views-' + sectionId + '-' + blockId;
  }

  function getCardViewsCount(root, card) {
    var sectionId = root.dataset.svsSectionId;
    var blockId = card.dataset.svsBlockId;
    var countEl = card.querySelector('[data-svs-views-count]');
    if (!sectionId || !blockId || !countEl) return null;

    var storageKey = getViewsStorageKey(sectionId, blockId);
    var stored = localStorage.getItem(storageKey);
    if (stored !== null) {
      var storedCount = parseInt(stored, 10);
      if (!isNaN(storedCount)) return storedCount;
    }

    return parseViewsText(countEl.dataset.svsViewsInitial || countEl.textContent);
  }

  function setCardViewsCount(root, card, count) {
    var sectionId = root.dataset.svsSectionId;
    var blockId = card.dataset.svsBlockId;
    var countEl = card.querySelector('[data-svs-views-count]');
    if (!sectionId || !blockId || !countEl) return;

    var safeCount = Math.max(0, count || 0);
    localStorage.setItem(getViewsStorageKey(sectionId, blockId), String(safeCount));
    countEl.textContent = formatViewsCount(safeCount);
  }

  function initViews(root) {
    if (root.dataset.svsAutoViews !== 'true') return;

    root.querySelectorAll('[data-svs-card]').forEach(function (card) {
      var count = getCardViewsCount(root, card);
      if (count === null) return;
      setCardViewsCount(root, card, count);
    });
  }

  function incrementCardViews(root, card) {
    if (root.dataset.svsAutoViews !== 'true') return;
    var count = getCardViewsCount(root, card);
    if (count === null) return;
    setCardViewsCount(root, card, count + 1);
  }

  function getColCount(section) {
    var style = getComputedStyle(section);
    var isMobile = window.innerWidth <= MOBILE_MAX;
    var prop = isMobile ? '--svs-cols-mobile' : '--svs-cols-desktop';
    var val = parseInt(style.getPropertyValue(prop).trim(), 10);
    return isNaN(val) || val < 1 ? (isMobile ? 2 : 4) : val;
  }

  function getMuteLabels(sliderRoot) {
    var root = sliderRoot || document.querySelector('.social-video-slider');
    return {
      unmute: (root && root.dataset.svsUnmuteLabel) || 'Sesi aç',
      mute: (root && root.dataset.svsMuteLabel) || 'Sesi kapat',
    };
  }

  function updateMuteButton(muteBtn, isMuted, labels) {
    if (!muteBtn) return;
    muteBtn.setAttribute('aria-label', isMuted ? labels.unmute : labels.mute);
    muteBtn.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
    muteBtn.classList.toggle('is-unmuted', !isMuted);
  }

  function initCarousel(root) {
    if (root.dataset.svsInit === 'true') return;
    root.dataset.svsInit = 'true';

    var track = root.querySelector('[data-svs-track]');
    var viewport = root.querySelector('[data-svs-viewport]');
    var prevBtn = root.querySelector('[data-svs-prev]');
    var nextBtn = root.querySelector('[data-svs-next]');
    var section = root.closest('.social-video-slider-section') || root;
    if (!track || !viewport || !track.children.length) return;

    var index = 0;

    function slideWidth() {
      var first = track.children[0];
      return first ? first.offsetWidth : 200;
    }

    function gap() {
      return parseFloat(getComputedStyle(track).gap) || 16;
    }

    function maxIndex() {
      var cols = getColCount(section);
      return Math.max(0, track.children.length - cols);
    }

    function updateNav() {
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex();
    }

    function goTo(nextIndex) {
      var max = maxIndex();
      index = Math.max(0, Math.min(max, nextIndex));
      var sw = slideWidth();
      var g = gap();
      track.style.transform = 'translate3d(' + -(index * (sw + g)) + 'px, 0, 0)';
      updateNav();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(index - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    window.addEventListener('resize', function () {
      goTo(index);
    });

    goTo(0);

    var touchStartX = 0;
    viewport.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );
    viewport.addEventListener(
      'touchend',
      function (e) {
        var delta = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(delta) < 40) return;
        goTo(index + (delta < 0 ? 1 : -1));
      },
      { passive: true }
    );
  }

  function resetCardAudio(card, sliderRoot) {
    var video = card.querySelector('video');
    var muteBtn = card.querySelector('[data-svs-mute]');
    if (!video) return;
    video.muted = true;
    card.classList.remove('is-unmuted');
    if (muteBtn) {
      updateMuteButton(muteBtn, true, getMuteLabels(sliderRoot));
    }
  }

  function pauseAllCards(root) {
    root.querySelectorAll('[data-svs-card].is-playing').forEach(function (card) {
      card.classList.remove('is-playing');
      var video = card.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      resetCardAudio(card, root);
    });
  }

  function initPopup(root) {
    var popup = root.querySelector('[data-svs-popup]');
    if (!popup || popup.dataset.svsPopupInit === 'true') return;
    popup.dataset.svsPopupInit = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-svs-card]'));
    if (!cards.length) return;

    var closeButtons = popup.querySelectorAll('[data-svs-popup-close], [data-svs-popup-close-mobile]');
    var prevBtn = popup.querySelector('[data-svs-popup-prev]');
    var nextBtn = popup.querySelector('[data-svs-popup-next]');
    var mainImage = popup.querySelector('.popup-main-image');
    var mainVideo = popup.querySelector('.popup-main-video');
    var titleEl = popup.querySelector('.popup-title');
    var usernameEl = popup.querySelector('.popup-username');
    var linkWrap = popup.querySelector('.svs-popup-individual-link');
    var linkEl = popup.querySelector('[data-svs-popup-link]');
    var sideImageWrap = popup.querySelector('[data-svs-popup-side-image-wrap]');
    var sideImageEl = popup.querySelector('[data-svs-popup-side-image]');
    var mobileImageSlide = popup.querySelector('[data-svs-popup-mobile-image-slide]');
    var mobileSideImageEl = popup.querySelector('[data-svs-popup-mobile-side-image]');
    var mediaViewport = popup.querySelector('[data-svs-popup-media-viewport]');
    var mediaTrack = popup.querySelector('[data-svs-popup-media-track]');
    var mediaDots = popup.querySelector('[data-svs-popup-media-dots]');
    var mediaNav = popup.querySelector('[data-svs-popup-media-nav]');
    var mediaPrevBtn = popup.querySelector('[data-svs-popup-media-prev]');
    var mediaNextBtn = popup.querySelector('[data-svs-popup-media-next]');
    var mediaArea = popup.querySelector('.svs-popup-media-area');
    var productsSection = popup.querySelector('.popup-products');
    var productsList = popup.querySelector('.popup-products-list');

    var currentIndex = 0;
    var mediaIndex = 0;
    var mediaTouchStartX = 0;
    var mediaSliderInteracted = false;
    var allowUserVideoPlay = false;
    var blockVideoPlayUntil = 0;
    var MOBILE_POPUP_MAX = 834;

    function isMobilePopup() {
      return window.innerWidth <= MOBILE_POPUP_MAX;
    }

    function hasMobileImageSlide() {
      return (
        mobileImageSlide &&
        !mobileImageSlide.classList.contains('svs-popup-mobile-slide-hidden')
      );
    }

    function updateMediaNav() {
      if (!mediaNav) return;

      var show = isMobilePopup() && hasMobileImageSlide();
      mediaNav.hidden = !show;

      if (mediaPrevBtn) mediaPrevBtn.disabled = mediaIndex <= 0;
      if (mediaNextBtn) mediaNextBtn.disabled = mediaIndex >= 1;
    }

    function pausePopupVideo() {
      if (mainVideo) mainVideo.pause();
    }

    function syncPopupVideoPlayback() {
      if (!mainVideo) return;

      if (isMobilePopup() && hasMobileImageSlide()) {
        pausePopupVideo();
      } else if (mediaIndex === 1) {
        pausePopupVideo();
      }
    }

    function updateMediaSlider(animate) {
      if (!mediaTrack || !hasMobileImageSlide()) {
        if (mediaTrack) mediaTrack.style.transform = '';
        if (mediaDots) mediaDots.hidden = true;
        updateMediaNav();
        return;
      }

      if (!isMobilePopup()) {
        mediaTrack.style.transform = '';
        mediaIndex = 0;
        if (mediaDots) mediaDots.hidden = true;
        updateMediaNav();
        return;
      }

      if (animate) {
        mediaSliderInteracted = true;
        allowUserVideoPlay = false;
        blockVideoPlayUntil = Date.now() + 500;
        pausePopupVideo();
      }

      mediaIndex = Math.max(0, Math.min(1, mediaIndex));
      var slideWidth = mediaViewport ? mediaViewport.offsetWidth : 0;
      mediaTrack.style.transition = animate
        ? 'transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
        : 'none';
      mediaTrack.style.transform = 'translate3d(' + -(mediaIndex * slideWidth) + 'px, 0, 0)';

      if (mediaDots) {
        mediaDots.hidden = false;
        var dots = mediaDots.querySelectorAll('[data-media-index]');
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === mediaIndex);
        });
      }

      syncPopupVideoPlayback();
      updateMediaNav();
    }

    function renderMediaDots() {
      if (!mediaDots) return;
      mediaDots.innerHTML = '';
      if (!isMobilePopup() || !hasMobileImageSlide()) {
        mediaDots.hidden = true;
        return;
      }
      for (var i = 0; i < 2; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'svs-popup-media-dot' + (i === mediaIndex ? ' is-active' : '');
        dot.dataset.mediaIndex = String(i);
        dot.setAttribute('aria-label', i === 0 ? 'Video' : 'Görsel');
        mediaDots.appendChild(dot);
      }
      mediaDots.hidden = false;
    }

    function getVideoSources(blockId) {
      var script = root.querySelector('.svs-video-sources[data-block-id="' + blockId + '"]');
      if (!script) return null;
      try {
        return JSON.parse(script.textContent).sources;
      } catch (error) {
        return null;
      }
    }

    function playPopupVideo() {
      if (!mainVideo) return;

      mainVideo.muted = false;

      function tryPlay() {
        var playPromise = mainVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }

      if (mainVideo.readyState >= 2) {
        tryPlay();
        return;
      }

      mainVideo.addEventListener('canplay', tryPlay, { once: true });
    }

    function loadVideo(card) {
      if (!mainVideo) return;

      mainVideo.pause();
      mainVideo.removeAttribute('poster');
      mainVideo.innerHTML = '';
      mainVideo.muted = false;

      var poster = card.dataset.svsVideoPoster;
      if (poster) mainVideo.poster = poster;

      var videoType = card.dataset.svsVideoType;
      var videoUrl = card.dataset.svsVideoUrl;

      if (videoType === 'shopify') {
        var sources = getVideoSources(card.dataset.svsBlockId);
        if (sources && sources.length) {
          var mp4 = sources.find(function (s) {
            return s.format === 'mp4';
          });
          var ordered = mp4
            ? [mp4].concat(
                sources.filter(function (s) {
                  return s !== mp4;
                })
              )
            : sources;
          ordered.forEach(function (source) {
            var el = document.createElement('source');
            el.src = source.url;
            el.type = source.type;
            mainVideo.appendChild(el);
          });
        } else if (videoUrl) {
          var fallback = document.createElement('source');
          fallback.src = videoUrl;
          fallback.type =
            videoUrl.indexOf('.m3u8') !== -1 ? 'application/x-mpegURL' : 'video/mp4';
          mainVideo.appendChild(fallback);
        }
      } else if (videoType === 'external' && videoUrl) {
        var external = document.createElement('source');
        external.src = videoUrl;
        external.type = 'video/mp4';
        mainVideo.appendChild(external);
      }

      mainVideo.load();
    }

    function loadProduct(blockId) {
      if (!productsList || !productsSection) return;

      var template = root.querySelector('.svs-hidden-product-template[data-block-id="' + blockId + '"]');
      if (template) {
        productsList.innerHTML = template.innerHTML;
        productsSection.style.display = 'block';

        productsList.querySelectorAll('.switch-apps-gallery-item-product-content > a').forEach(function (link) {
          var fullTitle = link.textContent.trim();
          if (fullTitle) link.setAttribute('title', fullTitle);
        });
      } else {
        productsList.innerHTML = '';
        productsSection.style.display = 'none';
      }
    }

    function populatePopup(card, index) {
      currentIndex = index;
      mediaSliderInteracted = false;
      allowUserVideoPlay = false;
      mediaIndex = 0;

      if (mainImage) mainImage.style.display = 'none';
      if (mainVideo) {
        mainVideo.style.display = 'none';
        loadVideo(card);
      }

      if (card.dataset.svsVideoType !== 'none' && mainVideo) {
        mainVideo.style.display = 'block';
        if (!mediaSliderInteracted && mediaIndex === 0) {
          playPopupVideo();
        } else {
          pausePopupVideo();
        }
      }

      if (titleEl) {
        titleEl.textContent = card.dataset.svsPopupTitle || '';
      }

      if (usernameEl) {
        usernameEl.textContent = card.dataset.svsPopupUsername || card.dataset.svsHandle || '';
      }

      if (linkWrap && linkEl) {
        var linkLabel = card.dataset.svsLinkLabel;
        var linkUrl = card.dataset.svsLinkUrl;
        if (linkLabel && linkUrl) {
          linkEl.textContent = linkLabel;
          linkEl.href = linkUrl;
          linkWrap.style.display = 'flex';
          if (card.dataset.svsLinkNewTab === 'true') {
            linkEl.target = '_blank';
            linkEl.rel = 'noopener noreferrer';
          } else {
            linkEl.removeAttribute('target');
            linkEl.removeAttribute('rel');
          }
        } else {
          linkWrap.style.display = 'none';
          linkEl.removeAttribute('href');
        }
      }

      if (sideImageWrap && sideImageEl) {
        var sideImageUrl = card.dataset.svsPopupImage;
        if (sideImageUrl) {
          sideImageEl.src = sideImageUrl;
          sideImageEl.alt = card.dataset.svsPopupTitle || '';
          sideImageWrap.classList.add('is-visible');

          if (mobileSideImageEl) {
            mobileSideImageEl.src = sideImageUrl;
            mobileSideImageEl.alt = card.dataset.svsPopupTitle || '';
          }
          if (mobileImageSlide) {
            mobileImageSlide.classList.remove('svs-popup-mobile-slide-hidden');
          }
          if (mediaArea) mediaArea.classList.add('has-side-image');
        } else {
          sideImageEl.removeAttribute('src');
          sideImageWrap.classList.remove('is-visible');
          if (mobileSideImageEl) mobileSideImageEl.removeAttribute('src');
          if (mobileImageSlide) {
            mobileImageSlide.classList.add('svs-popup-mobile-slide-hidden');
          }
          if (mediaArea) mediaArea.classList.remove('has-side-image');
        }
      }

      renderMediaDots();
      updateMediaSlider(false);

      loadProduct(card.dataset.svsBlockId);

      if (prevBtn) prevBtn.style.display = index > 0 ? 'flex' : 'none';
      if (nextBtn) nextBtn.style.display = index < cards.length - 1 ? 'flex' : 'none';
    }

    function openPopup(card, options) {
      options = options || {};
      var index = parseInt(card.dataset.svsIndex, 10);
      if (isNaN(index)) index = cards.indexOf(card);
      if (index < 0) return;

      if (options.countView) {
        incrementCardViews(root, card);
      }

      pauseAllCards(root);
      populatePopup(card, index);

      popup.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(function () {
        renderMediaDots();
        updateMediaSlider(false);
      });
    }

    function closePopup() {
      if (mainVideo) {
        mainVideo.pause();
        mainVideo.innerHTML = '';
        mainVideo.style.display = 'none';
      }
      if (mainImage) mainImage.style.display = 'none';

      popup.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (event.target.closest('[data-svs-mute]')) return;
        event.preventDefault();
        openPopup(card, { countView: true });
      });

      card.addEventListener('keydown', function (event) {
        if (event.target.closest('[data-svs-mute]')) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openPopup(card, { countView: true });
      });
    });

    if (closeButtons.length) {
      closeButtons.forEach(function (closeBtn) {
        closeBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          closePopup();
        });
      });
    }

    popup.addEventListener('click', function (event) {
      if (event.target === popup) {
        event.preventDefault();
        closePopup();
      }
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        if (currentIndex > 0) openPopup(cards[currentIndex - 1]);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        if (currentIndex < cards.length - 1) openPopup(cards[currentIndex + 1]);
      });
    }

    popup.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.getAttribute('aria-expanded') === 'true') {
        closePopup();
      }
    });

    if (mainVideo) {
      mainVideo.addEventListener('click', function () {
        if (!isMobilePopup() || !hasMobileImageSlide() || mediaIndex !== 0) return;
        if (Date.now() >= blockVideoPlayUntil) {
          allowUserVideoPlay = true;
        }
      });

      mainVideo.addEventListener('play', function () {
        if (!isMobilePopup() || !hasMobileImageSlide()) return;

        if (mediaIndex === 1 || Date.now() < blockVideoPlayUntil) {
          pausePopupVideo();
          return;
        }

        if (mediaSliderInteracted && !allowUserVideoPlay) {
          pausePopupVideo();
          return;
        }

        allowUserVideoPlay = false;
      });
    }

    if (mediaDots) {
      mediaDots.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-media-index]');
        if (!dot) return;
        mediaIndex = parseInt(dot.dataset.mediaIndex, 10) || 0;
        updateMediaSlider(true);
      });
    }

    if (mediaPrevBtn) {
      mediaPrevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (mediaIndex <= 0) return;
        mediaIndex -= 1;
        updateMediaSlider(true);
      });
    }

    if (mediaNextBtn) {
      mediaNextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (mediaIndex >= 1) return;
        mediaIndex += 1;
        updateMediaSlider(true);
      });
    }

    if (mediaViewport) {
      mediaViewport.addEventListener(
        'touchstart',
        function (event) {
          if (!isMobilePopup() || !hasMobileImageSlide()) return;
          mediaTouchStartX = event.changedTouches[0].screenX;
        },
        { passive: true }
      );

      mediaViewport.addEventListener(
        'touchend',
        function (event) {
          if (!isMobilePopup() || !hasMobileImageSlide()) return;
          var delta = event.changedTouches[0].screenX - mediaTouchStartX;
          if (Math.abs(delta) < 40) return;
          if (delta < 0 && mediaIndex < 1) mediaIndex += 1;
          if (delta > 0 && mediaIndex > 0) mediaIndex -= 1;
          updateMediaSlider(true);
        },
        { passive: true }
      );
    }

    window.addEventListener('resize', function () {
      if (popup.getAttribute('aria-expanded') !== 'true') return;
      renderMediaDots();
      updateMediaSlider(false);
    });
  }

  function initCards(root) {
    var muteLabels = getMuteLabels(root);

    root.querySelectorAll('[data-svs-card]').forEach(function (card) {
      if (card.dataset.svsCardInit === 'true') return;
      card.dataset.svsCardInit = 'true';

      var video = card.querySelector('video');
      if (!video) return;

      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.controls = false;
      video.loop = true;
      video.preload = 'metadata';

      var muteBtn = card.querySelector('[data-svs-mute]');
      if (muteBtn) {
        updateMuteButton(muteBtn, true, muteLabels);
        muteBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (!card.classList.contains('is-playing')) {
            card.classList.add('is-playing');
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {
                card.classList.remove('is-playing');
              });
            }
          }

          video.muted = !video.muted;
          updateMuteButton(muteBtn, video.muted, muteLabels);
        });
      }
    });
  }

  function initSection(section) {
    initCarousel(section);
    initViews(section);
    initCards(section);
    initPopup(section);
  }

  function initAll() {
    document.querySelectorAll('.social-video-slider').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.social-video-slider');
    if (section) initSection(section);
  });
})();
